import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { iTranslation } from 'src/components/shared-components/interfaces/iTranslation';

@Component({
    selector: 'app-deleted-content',
    templateUrl: './deleted-content.component.html',
    styleUrls: ['./deleted-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeletedContentComponent implements OnInit, iTranslation {

  private _translateSubscription: Subscription = null;
  private _lblElementDeleted: string = "L'elemento collegato non esiste più, è stato cancellato";

  public realtText: string = "";

  @Input() text: string;

  constructor(
    private _translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();

    if (!this.text) {
      this.realtText = this._lblElementDeleted;
    } else {
      this.realtText = this.text;
    }
  }

  ngOnDestroy() {
    this._translateSubscription.unsubscribe();
  }

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get([
        "dictionary.elementDeleted",
      ])
      .subscribe((translation) => {
        this._lblElementDeleted = translation["dictionary.elementDeleted"];
      });
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion


}
